import React from "react";
import { FileSpreadsheet, FileSearch } from "lucide-react";

const MARK_CLASS = "h-4 w-4 shrink-0 text-slate-400";

/** QuickBooks-style circular mark (icon only, no SVG text paths). */
function QuickBooksMark({ className = MARK_CLASS }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      role="img"
      aria-label="QuickBooks"
    >
      <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.2" />
      <path d="M12 4a8 8 0 108 8 8 8 0 00-8-8zm-.1 2.1c.7 0 1.3.2 1.9.5l-.8 2.4a1.5 1.5 0 00-.6-.12c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4c.7 0 1.2-.5 1.4-1.1l1.7 3h-2l-1.1-2a2.8 2.8 0 01-1.6.5c-1.9 0-3.5-1.6-3.5-3.5S9.9 6.1 11.9 6.1z" />
    </svg>
  );
}

/** Xero-style logomark (icon only, no SVG text paths). */
function XeroMark({ className = MARK_CLASS }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" role="img" aria-label="Xero">
      <path d="M14.2 5.5L10.5 12.5 6.8 5.5H4.2l5.5 11.2L3.8 18.5h2.6l3.5-3.2 3.5 3.2h2.6l-5.8-4 5.5-11.2h-2.6z" />
    </svg>
  );
}

const INGEST_PLATFORMS = [
  { id: "quickbooks", label: "QuickBooks", Mark: QuickBooksMark },
  { id: "xero", label: "Xero", Mark: XeroMark },
  { id: "ledger", label: "Excel / CSV Ledger", Mark: FileSpreadsheet },
  { id: "pdf", label: "PDF Notice Scan", Mark: FileSearch },
];

export default function IntegrationIngestLogos() {
  return (
    <div className="w-full mt-6">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3 text-center md:text-left">
        Supported Document Formats
      </p>
      <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-6 gap-y-3 mt-4 text-xs font-semibold uppercase tracking-wider text-slate-400">
        {INGEST_PLATFORMS.map(({ id, label, Mark }) => (
          <span key={id} className="inline-flex items-center gap-2 whitespace-nowrap">
            <Mark className={MARK_CLASS} aria-hidden />
            <span>{label}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
